module.exports = __webpack_public_path__ + "../front_assets/img/english.b7bd70a0.png";